// ** React Imports
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLoginConfiguration } from '@src/redux/authentication'

export const useJwt = () => {
  // ** Hooks
  const dispatch = useDispatch();
  const jwtService = useSelector((state) => state.auth.jwtService);

  const setJwtService = authConfiguration => {
    dispatch(setLoginConfiguration({
      config: authConfiguration
    }));
  };

  return { jwtService, setJwtService };
};
